module.exports = __webpack_public_path__ + "media/images/icon-cross-cbb4cb9dc8ee0f4b0c9decac883a99e2.png";